export interface RemoveInvoicesDialogDataInterface {
  invoicesToRemove: number;
}

export class RemoveInvoicesDialogData implements RemoveInvoicesDialogDataInterface {
  constructor(public invoicesToRemove: number) {}
}
